import GSAP from 'gsap';
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin';
import Component from '../classes/Component';
import { COLOR_BLACK, COLOR_WHITE } from '../utils/colors';

GSAP.registerPlugin(MorphSVGPlugin);

export default class Navigation extends Component {
  constructor({ template, lenis }) {
    super({
      element: '.navigation',
      elements: {
        links: '.navigation__links--desktop a',
        mobile: '.navigation__links--mobile',
        mobileLinks: '.mobile-links__wrapper a',
        logo: '.navigation__logo__image',
        mobileIconPath: '#navigation-icon-path path',
      },
    });

    this.lenis = lenis;
    this.template = template;

    this.hamburgerPath = 'M3 6H21M3 12H21M3 18H21';
    this.closePath = 'M4 4L20 20M20 4L4 20';

    if (this.elements.mobileLinks) {
      GSAP.set(this.elements.mobileLinks, { yPercent: 100 });
    }

    this.btnOpen = document.querySelector('.navigation__icon');

    this.mobileListeners();
    this.setActiveLink(this.template);
  }

  // ─── Active Link ──────────────────────────────────────────────

  setActiveLink(template) {
    if (!this.elements.links) return;

    this.elements.links.forEach(link => {
      link.classList.remove('is-active');
      console.log('removed');
      if (link.dataset.template === template) {
        link.classList.add('is-active');
        console.log('active');
      }
    });
  }

  // ─── Page Change ──────────────────────────────────────────────

  onChange(template) {
    console.log(template);

    this.template = template;
    this.setActiveLink(template);
  }

  // ─── Mobile Open ──────────────────────────────────────────────

  openMobile() {
    GSAP.killTweensOf(this.elements.mobileLinks);

    GSAP.to(this.elements.mobileIconPath, {
      duration: 0.3,
      morphSVG: this.closePath,
      ease: 'power2.inOut',
    });

    GSAP.to(this.elements.mobileLinks, {
      yPercent: 0,
      duration: 0.6,
      ease: 'expo.out',
      stagger: {
        each: 0.08,
        from: 'start',
      },
      delay: 0.15,
    });

    this.elements.mobile.setAttribute('aria-expanded', true);
    if (this.btnOpen) this.btnOpen.setAttribute('aria-expanded', true);

    this.lenis.stop();
  }

  // ─── Mobile Close ─────────────────────────────────────────────

  closeMobile() {
    GSAP.killTweensOf(this.elements.mobileLinks);

    GSAP.to(this.elements.mobileIconPath, {
      duration: 0.3,
      morphSVG: this.hamburgerPath,
      ease: 'power2.inOut',
    });

    GSAP.to(this.elements.mobileLinks, {
      yPercent: 100,
      duration: 0.5,
      ease: 'expo.in',
      stagger: {
        each: 0.06,
        from: 'end',
      },
      onComplete: () => {
        this.lenis.start();
      },
    });

    this.elements.mobile.setAttribute('aria-expanded', false);
    if (this.btnOpen) this.btnOpen.setAttribute('aria-expanded', false);
  }

  // ─── Toggle ───────────────────────────────────────────────────

  onMobileClick() {
    const isExpanded =
      this.elements.mobile.getAttribute('aria-expanded') === 'true';
    if (isExpanded) {
      this.closeMobile();
    } else {
      this.openMobile();
    }
  }

  // ─── Listeners ────────────────────────────────────────────────

  mobileListeners() {
    if (this.btnOpen) {
      this.btnOpen.addEventListener('click', this.onMobileClick.bind(this));
    } else {
      console.warn('Mobile navigation icon (.navigation__icon) not found.');
    }

    this.elements.mobileLinks.forEach(link => {
      link.addEventListener('click', this.closeMobile.bind(this));
    });
  }
}
